// extracted by mini-css-extract-plugin
module.exports = {"icon":"s1vm-ouY6xx9M67F_VsUY"};